import React from 'react';
import AboutUs from './AboutUs';
import ContactUs from './ContactUs';
import TermsConditions from './TermsConditions';
import PrivacyPolicy from './PrivacyPolicy';
import RefundPolicy from './RefundPolicy';
import DeliveryPolicy from './DeliveryPolicy';

// The information pages the payment gateway review expects to find, and the
// panel they are shown in.
//
// Shared by the corner menu and the page footer, so a page is registered once
// and both lists stay in step. Each opens as a full-screen panel over the order
// page rather than as a route, so no router change is needed and the customer
// keeps their cart when they come back.

// Order matters only for how the menu and the footer list read.
export const INFO_PAGES = {
    about: { title: 'About us', icon: 'pi pi-info-circle', render: () => <AboutUs /> },
    contact: { title: 'Contact us', icon: 'pi pi-phone', render: () => <ContactUs /> },
    terms: { title: 'Terms & Conditions', icon: 'pi pi-file', render: () => <TermsConditions /> },
    privacy: { title: 'Privacy Policy', icon: 'pi pi-lock', render: () => <PrivacyPolicy /> },
    refunds: { title: 'Refunds & Cancellation', icon: 'pi pi-replay', render: () => <RefundPolicy /> },
    delivery: { title: 'Delivery & Pickup', icon: 'pi pi-send', render: () => <DeliveryPolicy /> }
};

export const INFO_PAGE_ORDER = ['about', 'contact', 'terms', 'privacy', 'refunds', 'delivery'];

// `pageKey` is a key of INFO_PAGES, or null when nothing is open — so a caller
// can render this unconditionally and just hold the key in state.
export const InfoPanel = ({ pageKey, onClose }) => {
    // Escape closes it, matching the qty keypad. Owned here rather than by the
    // caller, so every way of opening a page gets the same behaviour.
    React.useEffect(() => {
        if (!pageKey) return undefined;

        const handleKeyDown = (e) => {
            if (e.key !== 'Escape') return;
            e.preventDefault();
            onClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [pageKey, onClose]);

    const page = pageKey ? INFO_PAGES[pageKey] : null;
    if (!page) return null;

    return (
        <div className="so-infopanel">
            <div className="so-infopanel__bar">
                <button
                    type="button"
                    className="so-infopanel__back"
                    onClick={onClose}
                    aria-label="Back"
                >
                    <i className="pi pi-arrow-left" />
                </button>
                <h2 className="so-infopanel__title">{page.title}</h2>
            </div>
            <div className="so-infopanel__body">{page.render()}</div>
        </div>
    );
};
